// src/components/AppSearch.js

import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PaperAirplaneIcon } from '@heroicons/react/24/solid';

const AppSearch = ({ app, values, onChange, onSubmit, isProcessing, timer }) => {
    const [currentValues, setCurrentValues] = useState(values || {});

    const handleChange = (key, value) => {
        const newValues = { ...currentValues, [key]: value };
        setCurrentValues(newValues);
        onChange(newValues);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(currentValues);
    };

    // Check if all required inputs have values
    const isFormValid = () => {
        if (!app || !app.inputs) return false;
        
        return app.inputs
            .filter(input => input.required)
            .every(input => currentValues[input.key] && currentValues[input.key].trim());
    };

    const renderInput = (input) => {
        switch (input.type) {
            case 'textarea':
                return (
                    <div className="mb-2" key={input.key}>
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                            {input.label || input.key}
                            {input.required && <span className="text-red-500 ml-1">*</span>}
                        </label>
                        <textarea
                            value={currentValues[input.key] || ''}
                            onChange={(e) => handleChange(input.key, e.target.value)}
                            placeholder={input.placeholder}
                            className="w-full p-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                            rows={3}
                            disabled={isProcessing}
                            required={input.required}
                        />
                    </div>
                );
            case 'text':
            default:
                return (
                    <div className="mb-2" key={input.key}>
                        <label className="block text-xs font-medium text-gray-700 mb-1">
                            {input.label || input.key}
                            {input.required && <span className="text-red-500 ml-1">*</span>}
                        </label>
                        <input
                            type="text"
                            value={currentValues[input.key] || ''}
                            onChange={(e) => handleChange(input.key, e.target.value)}
                            placeholder={input.placeholder}
                            className="w-full p-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                            disabled={isProcessing}
                            required={input.required}
                        />
                    </div>
                );
        }
    };

    return (
        <form onSubmit={handleSubmit} className="mb-3">
            {app.inputs && app.inputs.map(input => renderInput(input))}
            
            <motion.button
                whileHover={{ scale: 1.01 }}
                whileTap={{ scale: 0.99 }}
                type="submit"
                disabled={isProcessing || !isFormValid()}
                className={`w-full bg-white border border-gray-300 text-gray-700 font-medium py-2 px-4 rounded flex items-center justify-center text-sm ${isProcessing || !isFormValid() ? 'opacity-70 cursor-not-allowed' : 'hover:bg-gray-50'}`}
            >
                {isProcessing ? (
                    <div className="flex items-center">
                        <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-blue-500 mr-2"></div>
                        <span>Processing... {timer > 0 ? `${timer}s` : ''}</span>
                    </div>
                ) : (
                    <div className="flex items-center">
                        <img src={app.icon} alt="App icon" className="h-4 w-4 mr-2" />
                        <span>Generate</span>
                        <PaperAirplaneIcon className="h-3 w-3 ml-2" />
                    </div>
                )}
            </motion.button>
        </form>
    );
};

export default AppSearch;